import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import { reducer as formReducer } from 'redux-form';

import authReducer from './store/reducers/auth';
import settlementReducer from './store/reducers/settlement';
import accountReducer from './store/reducers/account';
import orderReducer from './store/reducers/order';
import logReducer from './store/reducers/log';
import homeReducer from './store/reducers/home';
import addToHomeScreenReducer from './store/reducers/addToHomeScreen';

import App from './App';
import registerServiceWorker from './registerServiceWorker';
import registerAddToHomeScreen from './util/registerAddToHomeScreen';

import './index.css';
import { ThemeProvider } from '@material-ui/core';
import theme from './util/theme';

const composeEnhancers = (process.env.NODE_ENV === 'development' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : null) || compose;
const basename = process.env.NODE_ENV === 'development' ? '/' : '/driver';

const rootReducer = combineReducers({
    auth: authReducer, 
    form: formReducer, 
    settlement: settlementReducer, 
    account: accountReducer, 
    order: orderReducer, 
    log: logReducer, 
    home: homeReducer, 
    addToHomeScreen: addToHomeScreenReducer
});

const store = createStore(rootReducer, composeEnhancers(
    applyMiddleware(thunk)
));

const app = (
    <Provider store={store}>
        <BrowserRouter basename={basename}>
            <ThemeProvider theme={theme}>
                <App />
            </ThemeProvider>
        </BrowserRouter>
    </Provider>
);

ReactDOM.render(app, document.getElementById('root'));
registerServiceWorker();
registerAddToHomeScreen(store.dispatch);